import { MI_RENTAL, NJ_RENTAL } from './AddVehicleConstants'

const validateMIBasicFormData = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      vehicleUsage,
      nameOfBank,
      annualMileage,
      vehicleOwnership,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionType,
      collisionCoverageDeductible,
      rentalReimbursement,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: { streetAddress: overnightStayStreetAddress, city, state, zipCode: overnightZipCode }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  let response = { isValid: true }
  if (
    firstName &&
    lastName &&
    policyNumber &&
    phoneNumber &&
    streetAddress &&
    zipCode &&
    emailAddress &&
    vin &&
    make &&
    year &&
    model &&
    purchaseDate &&
    stateRegistered &&
    registeredPersonFirstName &&
    registeredPersonLastName &&
    vehicleUsage &&
    annualMileage &&
    vehicleOwnership &&
    isVehicleWithCoOwnership &&
    otherCollisionCoverage &&
    isVehiclePrimarilyKeptOvernight &&
    isBusinessPurpose &&
    effectDate
  ) {
    if (isVehicleWithCoOwnership === 'Yes') {
      if (coOwnershipPersonFirstName && coOwnershipPersonLastName) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (otherCollisionCoverage === 'Yes') {
      if (otherCollisionDeductible && collisionCoverage) {
        if (collisionCoverage === 'Yes') {
          if (collisionType) {
            response = { isValid: true }
          } else {
            response = { isValid: false }
          }
          if (!response.isValid) {
            return { isValid: false }
          }
          if (collisionType !== 'Limited') {
            if (collisionCoverageDeductible) {
              response = { isValid: true }
            } else {
              response = { isValid: false }
            }
          } else if (collisionType === 'Limited') {
            response = { isValid: true }
          }
          if (!response.isValid) {
            return { isValid: false }
          }
        } else {
          response = { isValid: false }
        }
        if (rentalReimbursement) {
          response = { isValid: true }
        } else {
          response = { isValid: false }
        }
        if (!response.isValid) {
          return { isValid: false }
        }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isBusinessPurpose === 'Yes') {
      if (reason) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isVehiclePrimarilyKeptOvernight === 'No') {
      if (overnightStayStreetAddress && city && state && overnightZipCode) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') {
      if (nameOfBank) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
  } else {
    response = { isValid: false }
  }

  return response
}

const validatePABasicFormData = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      noOfDaysUsed,
      oneWayMiles,
      vehicleOwnership,
      nameOfBank,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionCoverageDeductible,
      rentalReimbursementCoverage,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: { streetAddress: overnightStayStreetAddress, city, state, zipCode: overnightZipCode }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  let response = { isValid: true }
  if (
    firstName &&
    lastName &&
    policyNumber &&
    phoneNumber &&
    streetAddress &&
    zipCode &&
    emailAddress &&
    vin &&
    make &&
    year &&
    model &&
    purchaseDate &&
    stateRegistered &&
    registeredPersonFirstName &&
    registeredPersonLastName &&
    noOfDaysUsed &&
    oneWayMiles &&
    vehicleOwnership &&
    isVehicleWithCoOwnership &&
    otherCollisionCoverage &&
    isVehiclePrimarilyKeptOvernight &&
    isBusinessPurpose &&
    effectDate
  ) {
    if (isVehicleWithCoOwnership === 'Yes') {
      if (coOwnershipPersonFirstName && coOwnershipPersonLastName) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (otherCollisionCoverage === 'Yes') {
      if (otherCollisionDeductible && collisionCoverage) {
        if (collisionCoverage === 'Yes') {
          if (collisionCoverageDeductible) {
            response = { isValid: true }
          } else {
            response = { isValid: false }
          }
          if (!response.isValid) {
            return { isValid: false }
          }
          if (rentalReimbursementCoverage) {
            response = { isValid: true }
          } else {
            response = { isValid: false }
          }
        } else {
          response = { isValid: true }
        }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isBusinessPurpose === 'Yes') {
      if (reason) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isVehiclePrimarilyKeptOvernight === 'No') {
      if (overnightStayStreetAddress && city && state && overnightZipCode) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') {
      if (nameOfBank) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
  } else {
    response = { isValid: false }
  }

  return response
}

const validateNJBasicFormData = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      noOfDaysUsed,
      registeredPersonFirstName,
      registeredPersonLastName,
      nameOfBank,
      oneWayMiles,
      vehicleOwnership,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionCoverageDeductible,
      rentalReimbursementCoverage,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: { streetAddress: overnightStayStreetAddress, city, state, zipCode: overnightZipCode }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  let response = { isValid: true }
  if (
    firstName &&
    lastName &&
    policyNumber &&
    phoneNumber &&
    streetAddress &&
    zipCode &&
    emailAddress &&
    vin &&
    make &&
    year &&
    model &&
    purchaseDate &&
    stateRegistered &&
    registeredPersonFirstName &&
    registeredPersonLastName &&
    oneWayMiles &&
    vehicleOwnership &&
    isVehicleWithCoOwnership &&
    otherCollisionCoverage &&
    isVehiclePrimarilyKeptOvernight &&
    isBusinessPurpose &&
    effectDate &&
    noOfDaysUsed
  ) {
    if (isVehicleWithCoOwnership === 'Yes') {
      if (coOwnershipPersonFirstName && coOwnershipPersonLastName) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (otherCollisionCoverage === 'Yes') {
      if (otherCollisionDeductible && collisionCoverage) {
        if (collisionCoverage === 'Yes') {
          if (collisionCoverageDeductible) {
            response = { isValid: true }
          } else {
            response = { isValid: false }
          }
        } else if (collisionCoverage === 'No') {
          response = { isValid: true }
        }
      } else {
        response = { isValid: false }
      }
      if (!response.isValid) {
        return { isValid: false }
      }
      if (rentalReimbursementCoverage) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    } else {
      response = { isValid: true }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isBusinessPurpose === 'Yes') {
      if (reason) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (isVehiclePrimarilyKeptOvernight === 'No') {
      if (overnightStayStreetAddress && city && state && overnightZipCode) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
    if (!response.isValid) {
      return { isValid: false }
    }
    if (vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') {
      if (nameOfBank) {
        response = { isValid: true }
      } else {
        response = { isValid: false }
      }
    }
  } else {
    response = { isValid: false }
  }

  return response
}

const validateDateNJ = vehicleInfo => {
  const { effectDate } = vehicleInfo

  if (new Date(effectDate).toString() === 'Invalid Date') {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const validateEmailNJ = vehicleInfo => {
  const { emailAddress } = vehicleInfo
  const regEx = /\S+@\S+\.\S+/

  if (emailAddress.length > 0 && regEx.test(emailAddress)) {
    return { isValid: true }
  } else {
    return { isValid: false }
  }
}

const validateZipCodeNJ = vehicleInfo => {
  const { zipCode } = vehicleInfo

  if (zipCode.length < 5) {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const validateDatePA = vehicleInfo => {
  const { effectDate } = vehicleInfo

  if (new Date(effectDate).toString() === 'Invalid Date') {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const validateEmailPA = vehicleInfo => {
  const { emailAddress } = vehicleInfo
  const regEx = /\S+@\S+\.\S+/

  if (emailAddress.length > 0 && regEx.test(emailAddress)) {
    return { isValid: true }
  } else {
    return { isValid: false }
  }
}

const validateZipCodePA = vehicleInfo => {
  const { zipCode } = vehicleInfo

  if (zipCode.length < 5) {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const validateDateMI = vehicleInfo => {
  const {
    vehicleInfo: { purchaseDate },
    effectDate
  } = vehicleInfo

  if (new Date(effectDate).toString() === 'Invalid Date' || new Date(purchaseDate).toString() === 'Invalid Date') {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const validateEmailMI = vehicleInfo => {
  const { emailAddress } = vehicleInfo
  const regEx = /\S+@\S+\.\S+/

  if (emailAddress.length > 0 && regEx.test(emailAddress)) {
    return { isValid: true }
  } else {
    return { isValid: false }
  }
}

const validateZipCodeMI = vehicleInfo => {
  const { zipCode } = vehicleInfo

  if (zipCode.length < 5) {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

const formatPhoneNumber = phoneNumber => {
  const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
  return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
}

const validatePhoneNumber = vehicleInfo => {
  const { phoneNumber } = vehicleInfo
  const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
  if (formatPhoneNumber(updatedNumber).length < 10) {
    return { isValid: false }
  } else {
    return { isValid: true }
  }
}

export const validateMIFields = vehicleInfo => {
  let validationResponse = true
  const initialResponse = validateMIBasicFormData(vehicleInfo)
  if (initialResponse.isValid) {
    const dateValidationResponse = validateDateMI(vehicleInfo)
    const emailValidationResponse = validateEmailMI(vehicleInfo)
    const zipCodeValidationResponse = validateZipCodeMI(vehicleInfo)
    const phoneValidationResponse = validatePhoneNumber(vehicleInfo)
    if (
      dateValidationResponse.isValid &&
      emailValidationResponse.isValid &&
      zipCodeValidationResponse.isValid &&
      phoneValidationResponse.isValid
    ) {
      validationResponse = true
    } else {
      validationResponse = false
    }
  } else {
    validationResponse = false
  }
  return validationResponse
}

export const validateNJFields = vehicleInfo => {
  let validationResponse = true
  const initialResponse = validateNJBasicFormData(vehicleInfo)
  if (initialResponse.isValid) {
    const dateValidationResponse = validateDateNJ(vehicleInfo)
    const emailValidationResponse = validateEmailNJ(vehicleInfo)
    const zipCodeValidationResponse = validateZipCodeNJ(vehicleInfo)
    const phoneValidationResponse = validatePhoneNumber(vehicleInfo)
    if (
      dateValidationResponse.isValid &&
      emailValidationResponse.isValid &&
      zipCodeValidationResponse.isValid &&
      phoneValidationResponse.isValid
    ) {
      validationResponse = true
    } else {
      validationResponse = false
    }
  } else {
    validationResponse = false
  }
  return validationResponse
}

export const validatePAFields = vehicleInfo => {
  let validationResponse = true
  const initialResponse = validatePABasicFormData(vehicleInfo)
  if (initialResponse.isValid) {
    const dateValidationResponse = validateDatePA(vehicleInfo)
    const emailValidationResponse = validateEmailPA(vehicleInfo)
    const zipCodeValidationResponse = validateZipCodePA(vehicleInfo)
    const phoneValidationResponse = validatePhoneNumber(vehicleInfo)
    if (
      dateValidationResponse.isValid &&
      emailValidationResponse.isValid &&
      zipCodeValidationResponse.isValid &&
      phoneValidationResponse.isValid
    ) {
      validationResponse = true
    } else {
      validationResponse = false
    }
  } else {
    validationResponse = false
  }
  return validationResponse
}

export const stripNJFinalJson = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      noOfDaysUsed,
      vehicleOwnership,
      nameOfBank,
      oneWayMiles,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionCoverageDeductible,
      rentalReimbursementCoverage,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: {
        streetAddress: overnightStayStreetAddress,
        apt,
        city,
        state,
        zipCode: overnightZipCode
      }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  const obj = {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    effectDate,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      noOfDaysUsed,
      oneWayMiles,
      vehicleOwnership,
      ...((vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') && {
        nameOfBank
      }),
      isVehicleWithCoOwnership,
      ...(isVehicleWithCoOwnership === 'Yes' && {
        coOwnershipPersonFirstName,
        coOwnershipPersonLastName
      }),
      otherCollisionCoverage,
      ...(otherCollisionCoverage === 'Yes' && {
        otherCollisionDeductible,
        collisionCoverage,
        rentalReimbursementCoverage: NJ_RENTAL[rentalReimbursementCoverage],
        ...(collisionCoverage === 'Yes' && {
          collisionCoverageDeductible
        })
      }),
      isVehiclePrimarilyKeptOvernight,
      ...(isVehiclePrimarilyKeptOvernight === 'No' && {
        overnightVehicleAddress: {
          streetAddress: overnightStayStreetAddress,
          apt,
          city,
          state,
          zipCode: overnightZipCode
        }
      })
    },
    isBusinessPurpose,
    ...(isBusinessPurpose === 'Yes' && {
      reason
    })
  }
  return obj
}

export const stripPAFinalJson = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      noOfDaysUsed,
      oneWayMiles,
      vehicleOwnership,
      nameOfBank,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionCoverageDeductible,
      rentalReimbursementCoverage,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: {
        streetAddress: overnightStayStreetAddress,
        apt,
        city,
        state,
        zipCode: overnightZipCode
      }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  const obj = {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      noOfDaysUsed,
      oneWayMiles,
      vehicleOwnership,
      ...((vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') && {
        nameOfBank
      }),
      isVehicleWithCoOwnership,
      ...(isVehicleWithCoOwnership === 'Yes' && {
        coOwnershipPersonFirstName,
        coOwnershipPersonLastName
      }),
      otherCollisionCoverage,
      ...(otherCollisionCoverage === 'Yes' && {
        otherCollisionDeductible,
        collisionCoverage,
        rentalReimbursementCoverage,
        ...(collisionCoverage === 'Yes' && {
          collisionCoverageDeductible
        })
      }),
      isVehiclePrimarilyKeptOvernight,
      ...(isVehiclePrimarilyKeptOvernight === 'No' && {
        overnightVehicleAddress: {
          streetAddress: overnightStayStreetAddress,
          apt,
          city,
          state,
          zipCode: overnightZipCode
        }
      })
    },
    isBusinessPurpose,
    ...(isBusinessPurpose === 'Yes' && {
      reason
    }),
    effectDate
  }
  return obj
}

export const stripMIFinalJson = vehicleInfo => {
  const {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      vehicleUsage,
      nameOfBank,
      annualMileage,
      vehicleOwnership,
      isVehicleWithCoOwnership,
      coOwnershipPersonFirstName,
      coOwnershipPersonLastName,
      otherCollisionCoverage,
      otherCollisionDeductible,
      collisionCoverage,
      collisionCoverageDeductible,
      rentalReimbursement,
      collisionType,
      isVehiclePrimarilyKeptOvernight,
      overnightVehicleAddress: {
        streetAddress: overnightStayStreetAddress,
        apt,
        city,
        state,
        zipCode: overnightZipCode
      }
    },
    isBusinessPurpose,
    reason,
    effectDate
  } = vehicleInfo

  const obj = {
    firstName,
    lastName,
    policyNumber,
    phoneNumber,
    streetAddress,
    zipCode,
    emailAddress,
    effectDate,
    vehicleInfo: {
      vin,
      year,
      make,
      model,
      purchaseDate,
      stateRegistered,
      registeredPersonFirstName,
      registeredPersonLastName,
      vehicleUsage,
      annualMileage,
      vehicleOwnership,
      ...((vehicleOwnership === 'Leased' || vehicleOwnership === 'Financed') && {
        nameOfBank
      }),
      isVehicleWithCoOwnership,
      ...(isVehicleWithCoOwnership === 'Yes' && {
        coOwnershipPersonFirstName,
        coOwnershipPersonLastName
      }),
      otherCollisionCoverage,
      ...(otherCollisionCoverage === 'Yes' && {
        otherCollisionDeductible,
        collisionCoverage,
        collisionType,
        rentalReimbursement: MI_RENTAL[rentalReimbursement],
        ...(collisionCoverage === 'Yes' &&
          collisionType !== 'Limited' && {
            collisionCoverageDeductible
          })
      }),
      isVehiclePrimarilyKeptOvernight,
      ...(isVehiclePrimarilyKeptOvernight === 'No' && {
        overnightVehicleAddress: {
          streetAddress: overnightStayStreetAddress,
          apt,
          city,
          state,
          zipCode: overnightZipCode
        }
      })
    },
    isBusinessPurpose,
    ...(isBusinessPurpose === 'Yes' && {
      reason
    })
  }

  return obj
}
